import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/factories')({
  staticData: {
    permissionSection: 'settings',
    section: 'Settings',
    breadcrumb: 'Factory Admin',
  },
  component: () => <Outlet />,
});
